import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Button, TextField } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';

function LoginPage() {
  const { handleLogin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [devEmail, setDevEmail] = useState('');
  const [devName, setDevName] = useState(''); // Add name input field

  const isMock = process.env.REACT_APP_MOCK_LOGIN === 'true';

  const handleDevLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await handleLogin(null, devEmail, devName); // Pass both email and name
      navigate('/home');
    } catch (err) {
      setError(err.message || 'Failed to dev login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    try {
      const idToken = credentialResponse.credential;
      if (idToken) {
        await handleLogin(idToken);
        navigate('/home');
      } else {
        setError('No ID token received.');
      }
    } catch (err) {
      console.error('Login Error:', err);
      setError('Failed to login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const onError = () => {
    setError('Google Sign-In was unsuccessful. Please try again.');
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f5f5f5"
    >
      <Box textAlign="center" mb={4}>
        <img src="/bluetab_an_IBM_Company.svg" alt="App Logo" style={{ width: 300, marginBottom: 16 }} />
        <Typography variant="h5" gutterBottom>
          Welcome to Bluetab Parking Pool
        </Typography>
      </Box>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {isMock ? (
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
              <TextField
                label="Email"
                variant="outlined"
                value={devEmail}
                onChange={(e) => setDevEmail(e.target.value)}
                fullWidth
              />
              <TextField
                label="Full Name"  // New input field for name
                variant="outlined"
                value={devName}
                onChange={(e) => setDevName(e.target.value)}
                fullWidth
              />
              <Button
                variant="contained"
                onClick={handleDevLogin}
                disabled={!devEmail || !devName} // Require both email and name
              >
                Dev Login (Skip Google)
              </Button>
            </Box>
          ) : (
            <GoogleLogin onSuccess={onSuccess} onError={onError} />
          )}
        </>
      )}
      {error && (
        <Typography color="error" mt={2}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default LoginPage;
